const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;
export type UtmParams = Partial<Record<typeof UTM_KEYS[number], string>>;

const STORAGE_KEY = 'pf_utm';
const EPIK_STORAGE_KEY = 'epik';

// Path-based UTM defaults — applied only when the URL has no utm_source,
// so user-supplied UTMs (paid ads, manual sharing) are always preserved.
// Add an entry per podcast/partner landing slot.
const PATH_UTM_DEFAULTS: Record<string, UtmParams> = {
  '/photobizx': { utm_source: 'photobizx', utm_medium: 'podcast', utm_campaign: 'guest_2026q2' },
};

export function captureUtm(): void {
  const params = new URLSearchParams(window.location.search);
  const utm: UtmParams = {};
  let found = false;
  for (const key of UTM_KEYS) {
    const val = params.get(key);
    if (val) {
      utm[key] = val;
      found = true;
    }
  }
  if (!found) {
    const defaults = PATH_UTM_DEFAULTS[window.location.pathname];
    if (defaults) {
      Object.assign(utm, defaults);
      found = true;
    }
  }
  if (found) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
    } catch {
      // storage unavailable
    }
  }
  // Capture Pinterest epik click ID (equivalent of Meta fbc)
  const epik = params.get('epik');
  if (epik) {
    try {
      sessionStorage.setItem(EPIK_STORAGE_KEY, epik);
    } catch {
      // storage unavailable
    }
  }
}

export function getUtm(): UtmParams {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function getEpik(): string | null {
  try {
    return sessionStorage.getItem(EPIK_STORAGE_KEY);
  } catch {
    return null;
  }
}
